// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4a-2";
export var blackBorderOnHover = "_4a-7";
export var cell = "_4a-6";
export var cellContainer = "_4a-3";
export var checked = "_4a-8";
export var disabled = "_4a-5";
export var featuredIconCellContainer = "_4a-9";
export var featuredIconTextContainer = "_4a-b";
export var featuredIconWrapper = "_4a-a";
export var noBorder = "_4a-c";
export var orangeSelectedRow = "_cz-3";
export var overflowableText = "_4a-0";
export var overflowableTextContainer = "_4a-1";
export var row = "_4b-0";
export var rowCheckboxCell = "_4a-4";
export var selectableTable = "_cz-2";